import { TextField, IconButton, InputLabel, FormHelperText } from '@mui/material';
import { FileUploadOutlined } from "@mui/icons-material";

export const File = ({ id, value, updateValue, path, description, errors, visible }) => {
  // console.log('value', value)

  const handleChange = (event) => {
    updateValue(event.target.files[0])
  }

  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      <InputLabel style={{ marginTop: '0.8em' }}>{description}</InputLabel>
      <TextField
        variant="standard"
        type="text"
        value={value?.name ?? ''}
        fullWidth={true}
        InputProps={{
          endAdornment: (
            <IconButton component="label">
              <FileUploadOutlined />
              <input
                styles={{display:"none"}}
                type="file"
                hidden
                onChange={handleChange}
                name={path}
              />
            </IconButton>
          ),
          readonly: true
        }}
        style={{ marginBottom: errors ? '0px' : undefined }}
        error={errors ? true : false}
      />
      { errors &&
        <FormHelperText error={true} filled={true}>{errors}</FormHelperText>
      }
    </div>
  );
};
